import { render } from "./ProfessionSelector.vue?vue&type=template&id=5f57ff22&scoped=true"
import script from "./ProfessionSelector.vue?vue&type=script&lang=js"
export * from "./ProfessionSelector.vue?vue&type=script&lang=js"

import "./ProfessionSelector.vue?vue&type=style&index=0&id=5f57ff22&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f57ff22"]])

export default __exports__